export enum ShippingCode {
    RELAY_POINT_COLISSIMO = "RELAY_POINT_COLISSIMO",
    RELAY_POINT_COLISSIMO_CONSIGNE = "RELAY_POINT_COLISSIMO_CONSIGNE",
    STANDARD = "STANDARD",
}
